module.exports = __webpack_public_path__ + "static/media/slide_1x2.7f787b05.png";